import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import Main from "../components/layout/Main";
import { Button, Col, Input, Row, Select, Tabs, Spin } from "antd";
import Search from "antd/lib/transfer/search";
import PostUser from "../assets/images/post-user.png";
import Post1 from "../assets/images/post-1.png";
import Comment from "../assets/images/comment.svg";
import Like from "../assets/images/like.svg";
import Heart from "../assets/images/heart.png";
import ScoreCard from "../assets/images/score-card.svg";
import avtarImg from "../assets/images/avtarImg.png";
import useRequest from "../hooks/useRequest";
import { useNavigate } from "react-router-dom";
import trophyIcon from "../assets/images/trophyIcon.png";
import warningImage from "../assets/images/warningImgae.jpg";
import { Link } from "react-router-dom";
import CommentModal from '../components/CommentModal'; // Import the modal

const { TabPane } = Tabs;

function Posts() {
  const [liked, setLiked] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const [posts, setPosts] = useState([]);
  const { request } = useRequest();
  const [loading, setLoading] = useState(true);
  const [selecttab, setselectedTab] = useState("1");
  const [handicap, sethandicap] = useState({});
  const [avgScore, setAvgcap] = useState({});
  const [setLike, setselectedLike] = useState();
  const [page, setPage] = useState(1);
  const [comment, setComment] = useState();
  const [addScore, setScore] = useState([]);
  const [profile, setProfile] = useState({});

  // Comment modal state
  const [commentModalVisible, setCommentModalVisible] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);

  // Touch event handling refs and state
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const minSwipeDistance = 50;

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  // Handle touch start event
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  // Handle touch end event
  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    handleSwipe();
  };

  // Process swipe direction and change tab accordingly
  const handleSwipe = useCallback(() => {
    if (!touchStartX.current || !touchEndX.current) return;

    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    const currentTabIndex = parseInt(selecttab);

    if (isLeftSwipe && currentTabIndex < 3) {
      const nextTab = (currentTabIndex + 1).toString();
      setselectedTab(nextTab);
    } else if (isRightSwipe && currentTabIndex > 1) {
      const prevTab = (currentTabIndex - 1).toString();
      setselectedTab(prevTab);
    }

    touchStartX.current = null;
    touchEndX.current = null;
  }, [selecttab]);

  const fetchPost = () => {
    console.log("hello its for just check");
    let type = selecttab === "1" ? "Friend" : selecttab === "2" ? "Public" : "User";
    request({
      url: `/app/post/get-post/${type}?page=${page}&limit=20`,
      method: "GET",
      onSuccess: (data) => {
        console.log("check post in post", data);
        setPosts(data.data.data);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    addDataPost();
    setUserProfile();
    setHandicapProfile();
    setAvg();
    fetchPost();
  }, [selecttab, page]);

  const addDataPost = (id) => {
    request({
      url: `app/game/gameBestScore`,
      method: "GET",
      onSuccess: (data) => {
        setScore(data.data.data);
        console.log("check post in post", data);
      },
      onError: (error) => {
        console.log(error);
      }
    });
  };

  const setHandicapProfile = () => {
    request({
      url: "app/game/getHandicapScore",
      method: "GET",
      onSuccess: (data) => {
        console.log("Handica[]:", data.data.name);
        sethandicap(data?.data);
      },
      onError: (error) => {
        console.log("Error fetching profile:", error);
      }
    });
  };

  const setAvg = () => {
    request({
      url: "app/game/averageTotalScore",
      method: "GET",
      onSuccess: (data) => {
        console.log("Handica[]:", data.data.totalAverage);
        setAvgcap(data.data);
      },
      onError: (error) => {
        console.log("Error fetching profile:", error);
      }
    });
  };

  const setUserProfile = () => {
    request({
      url: "app/user/get-profile",
      method: "GET",
      onSuccess: (data) => {
        console.log("Profile data:", data.data.name);
        setProfile(data.data);
      },
      onError: (error) => {
        console.log("Error fetching profile:", error);
      }
    });
  };

  const handleLikeClick = async (postId) => {
    try {
      // Optimistic update
      setPosts(prevPosts =>
        prevPosts.map(post =>
          post._id === postId 
            ? { 
                ...post, 
                isLike: !post.isLike,
                likeUserCount: post.isLike 
                  ? Math.max(0, post.likeUserCount - 1)
                  : post.likeUserCount + 1
              } 
            : post
        )
      );

      request({
        url: `/app/post/like-post/${postId}`,
        method: "GET",
        onSuccess: (data) => {
          // Success handled by optimistic update
        },
        onError: (error) => {
          console.log(error);
          // Revert optimistic update on error
          setPosts(prevPosts =>
            prevPosts.map(post =>
              post._id === postId 
                ? { 
                    ...post, 
                    isLike: !post.isLike,
                    likeUserCount: post.isLike 
                      ? post.likeUserCount + 1
                      : Math.max(0, post.likeUserCount - 1)
                  } 
                : post
            )
          );
        }
      });
    } catch (error) {
      console.error("Error liking post:", error);
    }
  };

  const handleTabs = (key) => {
    console.log('key', key);
    setselectedTab(key);
  };

  // Handle comment modal
  const handleCommentClick = (postId) => {
    setSelectedPostId(postId);
    setCommentModalVisible(true);
  };

  const handleCommentModalClose = () => {
    setCommentModalVisible(false);
    setSelectedPostId(null);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(event.target, 67);
    setComment(event.target.value);
  };

  function formatDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${month}-${day}-${year}`;
  }

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const handlePrevPage = () => {
    setPage(page - 1);
  };

  // Function to render posts - avoiding code duplication
  const renderPostContent = (posts) => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center' }}>
          <Spin size="large" tip="Loading..." style={{ color: '#04070c' }} />
        </div>
      );
    }

    if (posts.length === 0) {
      return (
        <div className="no-posts-available">
          <div className="image-container">
            <img src={warningImage} alt="No posts image" />
          </div>
        </div>
      );
    }

    return posts.map((post, index) => (
      <div className="single-post" key={index}>
        <div className="post-header">
          <div className="post-left">
            <div className="post-user">
              <div className="post-img">
                <img className="w-100 h-100" src={
                  post?.user[0].profilePic
                    ? `https://pwabucket1.s3.amazonaws.com/${post?.user[0].profilePic}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      post?.user[0].name
                    )}&size=256`
                } alt={post?.user[0].name} />
              </div>
              <div className="post-user-cont">
                <h4>{post?.user[0]?.name}</h4>
              </div>
            </div>
          </div>
          <div className="post-right">
            <div className="post_date">
              <p>{formatDate(post?.created_at)}</p>
            </div>
          </div>
        </div>
        {post?.media && (
          <div className="post-main-img">
            {post.media.endsWith('.mp4') ? (
              <video controls>
                <source src={`https://pwabucket1.s3.amazonaws.com/${post.media}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={`https://pwabucket1.s3.amazonaws.com/${post.media}`}
                alt="Post"
              />
            )}
          </div>
        )}
        <div className="post-mian-cont">
          <div className="post-tit">
            <h3>{post?.course}</h3>
            <p>{post?.description}</p>
          </div>
          <div className="single-post-dtl">
            {post.score && (
              <a className="btm-like" onClick={() => {
                if (post?.gameId[0]?._id) {
                  navigate(`/allScoreData/${post?.gameId[0]?._id}`);
                } else {
                  alert("Score card not available");
                }
              }}>
                <div className="score-post">
                  <div className="post-info-ic">
                    {post.score !== null ? post.score : 0}
                  </div>
                  <span>Score</span>
                </div>
              </a>
            )}
            {post.putts !== 0 && post.putts && (
              <div className="score-post">
                <div className="post-info-ic">
                  {post.putts}
                </div>
                <span>Putts</span>
              </div>
            )}
            {post.penalties !== 0 && post.penalties && (
              <div className="score-post">
                <div className="post-info-ic">
                  {post.penalties}
                </div>
                <span>Penalties</span>
              </div>
            )}
          </div>
          <div className="post-option">
            <ul>
              <li>
                {/* Updated comment button with custom styling */}
                <button 
                  className="btm-like comment-button"
                  onClick={() => handleCommentClick(post._id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    color: '#012b28' // Applied the requested color
                  }}
                >
                  <span className="post-icon" style={{ filter: 'invert(19%) sepia(30%) saturate(1089%) hue-rotate(146deg) brightness(95%) contrast(95%)' }}>
                    <img src={Comment} alt="Comment Icon" />
                  </span>
                  <span>Comment</span>
                </button>
              </li>
              <li>
                <button
                  className="btm-like"
                  onClick={() => handleLikeClick(post._id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px'
                  }}
                >
                  <span className="post-icon">
                    {post.isLike ? (
                      <img id="heart01" src={Heart} style={{ display: 'block' }} />
                    ) : (
                      <img id="heart02" src={Like} style={{ display: 'block' }} />
                    )}
                  </span>
                  <span>
                    {post.likeUserCount > 0 && `${post.likeUserCount}`}
                  </span>
                  <span> Like</span>
                </button>
              </li>
              <li>
                <a className="btm-like" onClick={() => {
                  if (post?.gameId[0]?._id) {
                    navigate(`/allScoreData/${post?.gameId[0]?._id}`);
                  } else {
                    alert("Score card not available");
                  }
                }}>
                  <span className="post-icon">
                    <img src={ScoreCard} />
                  </span>
                  <span>Scorecard</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <Main>
      <section className="home-wrap px-lg-4 px-3 container-fluid">
        <div className="row">
          <div className="col-lg-8">
            <section className="p-0 pt-2 container-fluid">
              <div
                className="posts-container"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                <Tabs className="tabin" activeKey={selecttab} onChange={handleTabs}>
                  <TabPane tab="FRIENDS POST" key="1" className="frndtab">
                    {renderPostContent(posts)}
                  </TabPane>
                  <TabPane tab="PUBLIC POST" key="2" className="frndtab">
                    {renderPostContent(posts)}
                  </TabPane>
                  <TabPane tab="SELF POST" key="3" className="frndtab">
                    {renderPostContent(posts)}
                  </TabPane>
                </Tabs>
              </div>

              <div className="pagination-buttons">
                <Button onClick={handlePrevPage} disabled={page <= 1}>Prev</Button>
                <Button onClick={handleNextPage}>Next</Button>
              </div>
            </section>
          </div>
          <div className="col-lg-4">
            <div className="sticky-post bg-white rounded-3">
              <div className="stickyPostHeader d-flex align-items-center justify-content-between w-100">
                <div className="stickyPostHeaderProfile d-flex align-items-center gap-2">
                  <div className="stickyPostHeaderProfileImg rounded-circle overflow-hidden">
                    <img
                      className="w-100 h-100"
                      src={
                        profile?.profilePic
                          ? `https://pwabucket1.s3.amazonaws.com/${profile?.profilePic}`
                          : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                            profile?.name
                          )}&size=256`
                      } />
                  </div>
                  <div className="stickyPostHeaderProfileDetail">
                    <div className="name">{profile.name}</div>
                    <div className="dec">{profile.email}</div>
                  </div>
                </div>
              </div>
              <div className="stickyPostGamesScoring row row-cols-xxs-2 row-cols-xs-3 row-cols-4 row-cols-sm-6 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 row-cols-xxxl-5 align-items-center g-3 pb-3 border-bottom w-100 justify-content-start">
                <div className="col scoringItems text-center">
                  <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">
                    {handicap?.totalAverage?.toString()?.substring(0, 5) || '0.0'}
                  </div>
                  <div className="title mt-1 ">Handicap</div>
                </div>
                <div className="col scoringItems text-center">
                  <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">{avgScore?.totalAverage?.toString()?.substring(0, 5) || '0.0'}</div>
                  <div className="title mt-1 ">Avg Score</div>
                </div>
                <div className="col scoringItems text-center">
                  <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">
                    {(avgScore?.averagePuttScore || 0).toFixed(2)}
                  </div>
                  <div className="title mt-1 ">Avg Putts</div>
                </div>
              </div>
              <div className="stickyPostTrophy d-flex flex-column gap-3 w-100">
                <div className="stickyPostTrophyHeader d-flex align-items-center justify-content-between w-100">
                  <div className="title">Trophy</div>
                </div>
                <div className="stickyPostTrophyOuter row g-2 row-cols-xxs-2 row-cols-xs-3 row-cols-4 row-cols-sm-6 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 row-cols-xxxl-5 align-items-center">
                  <div className="col">
                    <div className="stickyPostTrophyItem text-center">
                      <div className="imgOuter mx-auto position-relative">
                        <img className="w-100" src={trophyIcon} />
                        <div className="scor text-white position-absolute start-0 end-0 mx-auto z-1">{addScore[1] ? addScore[1] : 0}</div>
                      </div>
                      <div className="title">Best Score</div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="stickyPostTrophyItem text-center">
                      <div className="imgOuter mx-auto position-relative">
                        <img className="w-100" src={trophyIcon} />
                        <div className="scor text-white position-absolute start-0 end-0 mx-auto z-1">{addScore[0] ? addScore[0] : 0}</div>
                      </div>
                      <div className="title">Best Putts</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comment Modal */}
      <CommentModal
        visible={commentModalVisible}
        onClose={handleCommentModalClose}
        postId={selectedPostId}
      />
    </Main>
  );
}

export default Posts;


// import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
// import Main from "../components/layout/Main";
// import { Button, Col, Input, Row, Select, Tabs, Spin } from "antd";
// import Search from "antd/lib/transfer/search";
// import PostUser from "../assets/images/post-user.png";
// import Post1 from "../assets/images/post-1.png";
// import Comment from "../assets/images/comment.svg";
// import Like from "../assets/images/like.svg";
// import Heart from "../assets/images/heart.png";
// import ScoreCard from "../assets/images/score-card.svg";
// import avtarImg from "../assets/images/avtarImg.png";
// import useRequest from "../hooks/useRequest";
// import { useNavigate } from "react-router-dom";
// import trophyIcon from "../assets/images/trophyIcon.png";
// import warningImage from "../assets/images/warningImgae.jpg";
// import { Link } from "react-router-dom";
// import CommentModal from '../components/CommentModal'; // Import the modal

// const { TabPane } = Tabs;

// function Posts() {
//   const [liked, setLiked] = useState(false);
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("1");
//   const [posts, setPosts] = useState([]);
//   const { request } = useRequest();
//   const [loading, setLoading] = useState(true);
//   const [selecttab, setselectedTab] = useState("1");
//   const [handicap, sethandicap] = useState({});
//   const [avgScore, setAvgcap] = useState({});
//   const [setLike, setselectedLike] = useState();
//   const [page, setPage] = useState(1);
//   const [comment, setComment] = useState();
//   const [addScore, setScore] = useState([]);
//   const [profile, setProfile] = useState({});

//   // Comment modal state
//   const [commentModalVisible, setCommentModalVisible] = useState(false);
//   const [selectedPostId, setSelectedPostId] = useState(null);

//   // Touch event handling refs and state
//   const touchStartX = useRef(null);
//   const touchEndX = useRef(null);
//   const minSwipeDistance = 50;

//   const handleTabChange = (key) => {
//     setActiveTab(key);
//   };

//   // Handle touch start event
//   const handleTouchStart = (e) => {
//     touchStartX.current = e.touches[0].clientX;
//   };

//   // Handle touch end event
//   const handleTouchEnd = (e) => {
//     touchEndX.current = e.changedTouches[0].clientX;
//     handleSwipe();
//   };

//   // Process swipe direction and change tab accordingly
//   const handleSwipe = useCallback(() => {
//     if (!touchStartX.current || !touchEndX.current) return;

//     const distance = touchStartX.current - touchEndX.current;
//     const isLeftSwipe = distance > minSwipeDistance;
//     const isRightSwipe = distance < -minSwipeDistance;

//     const currentTabIndex = parseInt(selecttab);

//     if (isLeftSwipe && currentTabIndex < 3) {
//       const nextTab = (currentTabIndex + 1).toString();
//       setselectedTab(nextTab);
//     } else if (isRightSwipe && currentTabIndex > 1) {
//       const prevTab = (currentTabIndex - 1).toString();
//       setselectedTab(prevTab);
//     }

//     touchStartX.current = null;
//     touchEndX.current = null;
//   }, [selecttab]);

//   const fetchPost = () => {
//     console.log("hello its for just check");
//     let type = selecttab === "1" ? "Friend" : selecttab === "2" ? "Public" : "User";
//     request({
//       url: `/app/post/get-post/${type}?page=${page}&limit=20`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("check post in post", data);
//         setPosts(data.data.data);
//         setLoading(false);
//       },
//       onError: (error) => {
//         console.log(error);
//         setLoading(false);
//       }
//     });
//   };

//   useEffect(() => {
//     addDataPost();
//     setUserProfile();
//     setHandicapProfile();
//     setAvg();
//     fetchPost();
//   }, [selecttab, page]);

//   const addDataPost = (id) => {
//     request({
//       url: `app/game/gameBestScore`,
//       method: "GET",
//       onSuccess: (data) => {
//         setScore(data.data.data);
//         console.log("check post in post", data);
//       },
//       onError: (error) => {
//         console.log(error);
//       }
//     });
//   };

//   const setHandicapProfile = () => {
//     request({
//       url: "app/game/getHandicapScore",
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("Handica[]:", data.data.name);
//         sethandicap(data?.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching profile:", error);
//       }
//     });
//   };

//   const setAvg = () => {
//     request({
//       url: "app/game/averageTotalScore",
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("Handica[]:", data.data.totalAverage);
//         setAvgcap(data.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching profile:", error);
//       }
//     });
//   };

//   const setUserProfile = () => {
//     request({
//       url: "app/user/get-profile",
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("Profile data:", data.data.name);
//         setProfile(data.data);
//       },
//       onError: (error) => {
//         console.log("Error fetching profile:", error);
//       }
//     });
//   };

//   const handleLikeClick = async (postId) => {
//     try {
//       // Optimistic update
//       setPosts(prevPosts =>
//         prevPosts.map(post =>
//           post._id === postId 
//             ? { 
//                 ...post, 
//                 isLike: !post.isLike,
//                 likeUserCount: post.isLike 
//                   ? Math.max(0, post.likeUserCount - 1)
//                   : post.likeUserCount + 1
//               } 
//             : post
//         )
//       );

//       request({
//         url: `/app/post/like-post/${postId}`,
//         method: "GET",
//         onSuccess: (data) => {
//           // Success handled by optimistic update
//         },
//         onError: (error) => {
//           console.log(error);
//           // Revert optimistic update on error
//           setPosts(prevPosts =>
//             prevPosts.map(post =>
//               post._id === postId 
//                 ? { 
//                     ...post, 
//                     isLike: !post.isLike,
//                     likeUserCount: post.isLike 
//                       ? post.likeUserCount + 1
//                       : Math.max(0, post.likeUserCount - 1)
//                   } 
//                 : post
//             )
//           );
//         }
//       });
//     } catch (error) {
//       console.error("Error liking post:", error);
//     }
//   };

//   const handleTabs = (key) => {
//     console.log('key', key);
//     setselectedTab(key);
//   };

//   // Handle comment modal
//   const handleCommentClick = (postId) => {
//     setSelectedPostId(postId);
//     setCommentModalVisible(true);
//   };

//   const handleCommentModalClose = () => {
//     setCommentModalVisible(false);
//     setSelectedPostId(null);
//   };

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     console.log(event.target, 67);
//     setComment(event.target.value);
//   };

//   function formatDate(dateString) {
//     if (!dateString) return "";

//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');

//     return `${month}-${day}-${year}`;
//   }

//   const handleNextPage = () => {
//     setPage(page + 1);
//   };

//   const handlePrevPage = () => {
//     setPage(page - 1);
//   };

//   // Function to render posts - avoiding code duplication
//   const renderPostContent = (posts) => {
//     if (loading) {
//       return (
//         <div style={{ textAlign: 'center' }}>
//           <Spin size="large" tip="Loading..." style={{ color: '#04070c' }} />
//         </div>
//       );
//     }

//     if (posts.length === 0) {
//       return (
//         <div className="no-posts-available">
//           <div className="image-container">
//             <img src={warningImage} alt="No posts image" />
//           </div>
//         </div>
//       );
//     }

//     return posts.map((post, index) => (
//       <div className="single-post" key={index}>
//         <div className="post-header">
//           <div className="post-left">
//             <div className="post-user">
//               <div className="post-img">
//                 <img className="w-100 h-100" src={
//                   post?.user[0].profilePic
//                     ? `https://pwabucket1.s3.amazonaws.com/${post?.user[0].profilePic}`
//                     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                       post?.user[0].name
//                     )}&size=256`
//                 } alt={post?.user[0].name} />
//               </div>
//               <div className="post-user-cont">
//                 <h4>{post?.user[0]?.name}</h4>
//               </div>
//             </div>
//           </div>
//           <div className="post-right">
//             <div className="post_date">
//               <p>{formatDate(post?.created_at)}</p>
//             </div>
//           </div>
//         </div>
//         {post?.media && (
//           <div className="post-main-img">
//             {post.media.endsWith('.mp4') ? (
//               <video controls>
//                 <source src={`https://pwabucket1.s3.amazonaws.com/${post.media}`} type="video/mp4" />
//                 Your browser does not support the video tag.
//               </video>
//             ) : (
//               <img
//                 src={`https://pwabucket1.s3.amazonaws.com/${post.media}`}
//                 alt="Post"
//               />
//             )}
//           </div>
//         )}
//         <div className="post-mian-cont">
//           <div className="post-tit">
//             <h3>{post?.course}</h3>
//             <p>{post?.description}</p>
//           </div>
//           <div className="single-post-dtl">
//             {post.score && (
//               <a className="btm-like" onClick={() => {
//                 if (post?.gameId[0]?._id) {
//                   navigate(`/allScoreData/${post?.gameId[0]?._id}`);
//                 } else {
//                   alert("Score card not available");
//                 }
//               }}>
//                 <div className="score-post">
//                   <div className="post-info-ic">
//                     {post.score !== null ? post.score : 0}
//                   </div>
//                   <span>Score</span>
//                 </div>
//               </a>
//             )}
//             {post.putts !== 0 && post.putts && (
//               <div className="score-post">
//                 <div className="post-info-ic">
//                   {post.putts}
//                 </div>
//                 <span>Putts</span>
//               </div>
//             )}
//             {post.penalties !== 0 && post.penalties && (
//               <div className="score-post">
//                 <div className="post-info-ic">
//                   {post.penalties}
//                 </div>
//                 <span>Penalties</span>
//               </div>
//             )}
//           </div>
//           <div className="post-option">
//             <ul>
//               <li>
//                 {/* Replace Link with button for modal */}
//                 <button 
//                   className="btm-like"
//                   onClick={() => handleCommentClick(post._id)}
//                   style={{
//                     background: 'none',
//                     border: 'none',
//                     padding: 0,
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '5px'
//                   }}
//                 >
//                   <span className="post-icon">
//                     <img src={Comment} alt="Comment Icon" />
//                   </span>
//                   <span>Comment</span>
//                 </button>
//               </li>
//               <li>
//                 <button
//                   className="btm-like"
//                   onClick={() => handleLikeClick(post._id)}
//                   style={{
//                     background: 'none',
//                     border: 'none',
//                     padding: 0,
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '5px'
//                   }}
//                 >
//                   <span className="post-icon">
//                     {post.isLike ? (
//                       <img id="heart01" src={Heart} style={{ display: 'block' }} />
//                     ) : (
//                       <img id="heart02" src={Like} style={{ display: 'block' }} />
//                     )}
//                   </span>
//                   <span>
//                     {post.likeUserCount > 0 && `${post.likeUserCount}`}
//                   </span>
//                   <span> Like</span>
//                 </button>
//               </li>
//               <li>
//                 <a className="btm-like" onClick={() => {
//                   if (post?.gameId[0]?._id) {
//                     navigate(`/allScoreData/${post?.gameId[0]?._id}`);
//                   } else {
//                     alert("Score card not available");
//                   }
//                 }}>
//                   <span className="post-icon">
//                     <img src={ScoreCard} />
//                   </span>
//                   <span>Scorecard</span>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     ));
//   };

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 container-fluid">
//         <div className="row">
//           <div className="col-lg-8">
//             <section className="p-0 pt-2 container-fluid">
//               <div
//                 className="posts-container"
//                 onTouchStart={handleTouchStart}
//                 onTouchEnd={handleTouchEnd}
//               >
//                 <Tabs className="tabin" activeKey={selecttab} onChange={handleTabs}>
//                   <TabPane tab="FRIENDS POST" key="1" className="frndtab">
//                     {renderPostContent(posts)}
//                   </TabPane>
//                   <TabPane tab="PUBLIC POST" key="2" className="frndtab">
//                     {renderPostContent(posts)}
//                   </TabPane>
//                   <TabPane tab="SELF POST" key="3" className="frndtab">
//                     {renderPostContent(posts)}
//                   </TabPane>
//                 </Tabs>
//               </div>

//               <div className="pagination-buttons">
//                 <Button onClick={handlePrevPage} disabled={page <= 1}>Prev</Button>
//                 <Button onClick={handleNextPage}>Next</Button>
//               </div>
//             </section>
//           </div>
//           <div className="col-lg-4">
//             <div className="sticky-post bg-white rounded-3">
//               <div className="stickyPostHeader d-flex align-items-center justify-content-between w-100">
//                 <div className="stickyPostHeaderProfile d-flex align-items-center gap-2">
//                   <div className="stickyPostHeaderProfileImg rounded-circle overflow-hidden">
//                     <img
//                       className="w-100 h-100"
//                       src={
//                         profile?.profilePic
//                           ? `https://pwabucket1.s3.amazonaws.com/${profile?.profilePic}`
//                           : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                             profile?.name
//                           )}&size=256`
//                       } />
//                   </div>
//                   <div className="stickyPostHeaderProfileDetail">
//                     <div className="name">{profile.name}</div>
//                     <div className="dec">{profile.email}</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="stickyPostGamesScoring row row-cols-xxs-2 row-cols-xs-3 row-cols-4 row-cols-sm-6 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 row-cols-xxxl-5 align-items-center g-3 pb-3 border-bottom w-100 justify-content-start">
//                 <div className="col scoringItems text-center">
//                   <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">
//                     {handicap?.totalAverage?.toString()?.substring(0, 5) || '0.0'}
//                   </div>
//                   <div className="title mt-1 ">Handicap</div>
//                 </div>
//                 <div className="col scoringItems text-center">
//                   <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">{avgScore?.totalAverage?.toString()?.substring(0, 5) || '0.0'}</div>
//                   <div className="title mt-1 ">Avg Score</div>
//                 </div>
//                 <div className="col scoringItems text-center">
//                   <div className="scor d-flex align-items-center justify-content-center rounded-circle text-white mx-auto">
//                     {(avgScore?.averagePuttScore || 0).toFixed(2)}
//                   </div>
//                   <div className="title mt-1 ">Avg Putts</div>
//                 </div>
//               </div>
//               <div className="stickyPostTrophy d-flex flex-column gap-3 w-100">
//                 <div className="stickyPostTrophyHeader d-flex align-items-center justify-content-between w-100">
//                   <div className="title">Trophy</div>
//                 </div>
//                 <div className="stickyPostTrophyOuter row g-2 row-cols-xxs-2 row-cols-xs-3 row-cols-4 row-cols-sm-6 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 row-cols-xxxl-5 align-items-center">
//                   <div className="col">
//                     <div className="stickyPostTrophyItem text-center">
//                       <div className="imgOuter mx-auto position-relative">
//                         <img className="w-100" src={trophyIcon} />
//                         <div className="scor text-white position-absolute start-0 end-0 mx-auto z-1">{addScore[1] ? addScore[1] : 0}</div>
//                       </div>
//                       <div className="title">Best Score</div>
//                     </div>
//                   </div>
//                   <div className="col">
//                     <div className="stickyPostTrophyItem text-center">
//                       <div className="imgOuter mx-auto position-relative">
//                         <img className="w-100" src={trophyIcon} />
//                         <div className="scor text-white position-absolute start-0 end-0 mx-auto z-1">{addScore[0] ? addScore[0] : 0}</div>
//                       </div>
//                       <div className="title">Best Putts</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Comment Modal */}
//       <CommentModal
//         visible={commentModalVisible}
//         onClose={handleCommentModalClose}
//         postId={selectedPostId}
//       />
//     </Main>
//   );
// }

// export default Posts;
